<fieldset>
    <legend class="ib-gift-cards__title">{{"GIFT_CARD_YOUR_DATA" | translate}}</legend>
    <div class="ib-layout__line-spacing u-mb-mobile">
        <div [formGroup]="form"><!--formulario completo-->
            <div class="row">
                <div formGroupName="sender"><!--el grupo al que pertenecen los inputs de este div-->
                    <div class="col-md-6 col-sm-12 col-xs-12 u-mb-mobile">
                        <div class="ib-input">
                            <label class="ib-input__label" for="senderName"
                                [ngClass]="{'ib-input__label--focus' : nameFocused ||
                                    form.get('sender.name').value !== null}">{{"GIFT_CARD_USER_NAME" | translate}}</label>
                            <input class="ib-input__input" 
                                   type="text" 
                                   id="senderName" 
                                   name="senderName"
                                   formControlName="name"
                                   [attr.maxlength]="nameMaxLength"
                                   [attr.minlength]="nameMinLength"
                                   (focus)= "nameFocused = true"
                                   (blur)="nameFocused = false"

                            />
                        </div>
                        <!--TODO: mostrar error de requerido cuando el formulario esté submiteado se guarda en formIsSubmitted de IbGiftCardsContributionService-->
                        <div *ngIf="(form.get('sender.name').value === null || form.get('sender.name').value === '') && contributionService.formIsSubmitted" class="ib-alert ib-alert--error">{{'GENERAL_INPUT_REQUIRED_ERROR'|translate}}</div>
                        <div *ngIf="form.get('sender.name').errors?.pattern" class="ib-alert ib-alert--error">{{'GENERAL_INPUT_PATTERN_ERROR'|translate}}</div>
                        <div *ngIf="form.get('sender.name').errors?.lengthTooLow" class="ib-alert ib-alert--error">{{'GENERAL_NAME_MIN_LENGTH_ERROR'|translate}}</div> 
                    </div>

                    <!---Email-->
                    <div class="col-md-6 col-sm-12 col-xs-12 u-mb-mobile">
                        <div class="ib-input">
                            <label class="ib-input__label" for="senderEmail"
                                [ngClass]="{'ib-input__label--focus' : emailFocused ||
                                    form.get('sender.email').value !== null}">{{"GIFT_CARD_CONFIGURATION_EMAIL" | translate}}</label>
                            <input class="ib-input__input" 
                                   type="text" 
                                   id="senderEmail" 
                                   name="senderEmail"
                                   formControlName="email"
                                   (focus)= "emailFocused = true"
                                   (blur)="emailFocused = false"

                            />
                        </div>
                        <!--TODO: mostrar error de requerido cuando el formulario esté submiteado se guarda en formIsSubmitted de IbGiftCardsContributionService-->
                        <div *ngIf="(form.get('sender.email').value === null || form.get('sender.email').value === '') && contributionService.formIsSubmitted" class="ib-alert ib-alert--error">{{'GENERAL_INPUT_REQUIRED_ERROR'|translate}}</div>
                        <div *ngIf="form.get('sender.email').errors?.pattern && contributionService.formIsSubmitted" class="ib-alert ib-alert--error">{{'GENERAL_EMAIL_PATTERN_ERROR'|translate}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</fieldset>





            
                
                    
            
